import { ProfileIcon } from '../../icons';
import { Heading } from '../../common/form/form-parts';
import { Button } from 'tradera/components/atoms/button/button';
import { FormFooterLogo } from 'tradera/apps/registration/components/common/form/form-footer-logo';

export const SwedishPrivateProviderEmailExists = (props) => {
    const { providerName } = props;
    return (
        <>
            <div />
            <div className={'mt-7'}>
                <div className={'text-center'}>
                    <ProfileIcon size={80} />
                </div>
                <Heading>Logga in</Heading>
                <h4 className="font-weight-bold">
                    Jippi! Du finns redan på Tradera!
                </h4>
                <div className={'mb-3'}>
                    Ditt {providerName}-konto är registrerat med en epostadress
                    som redan finns på Tradera. Logga in med ditt
                    Tradera-lösenord för att koppla ihop kontona.
                </div>
                <Button theme="primary" fluid className="my-3" href="/login">
                    Gå till inloggning
                </Button>
                <div className={'text-center mb-3'}>
                    Har du problem? <a href={props.helpUrl}>Kontakta oss</a>
                </div>
            </div>
            <div className="text-center mb-4">
                <FormFooterLogo />
            </div>
        </>
    );
};
